import axios from "axios";
import { getCookie, removeCookie } from "../utils/cookieUtils";

const baseURL = process.env.REACT_APP_APIURL;
const DEBUG = process.env.REACT_APP_FLAGDEBUG;
const clienteAxios = axios.create({ baseURL });

//we intercept every request
clienteAxios.interceptors.request.use(
  async (config) => {
    config.headers["X-Api-Key"] = process.env.REACT_APP_API_KEY;
    if (config.headers["Content-Type"] !== 'multipart/form-data'){
      config.headers["Content-Type"] = "application/json";
    }
    const token = getCookie("token");
    if (token) {
      config.headers["X-Api-Token"] = token;
    }
    if (DEBUG === "S") {
      _printRequest(
        config.method,
        config.baseURL + config.url,
        config.headers,
        config.data
      );
    }
    return config;
  },
  (error) => {
    if (DEBUG === "S") {
      console.error(error);
    }
    return Promise.reject(error);
  }
);

// clienteAxios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;
//     console.log("entro a refreshtoken");
//     //Access Token was expired
//     if (error.response.status === 401 && !originalRequest._retry && !refresh) {
//     //if (error.response.status === 401 && !refresh) {
//       //originalRequest._retry = true;
//       try {
//         const token = localStorage.getItem("token");
//         console.log("token desde local")
//         const response = await clienteAxios.post("/refreshtoken", {
//           refreshToken: token,
//         });

//         if (!response){
//           return Promise.reject("Error");
//         }

//         const newAccessToken = response.data.token;
//         console.log("newAccessToken ->", newAccessToken);
//         localStorage.setItem("token", newAccessToken);
//         originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

//         //refreshToken = response.data.refreshToken;

//         return clienteAxios(originalRequest);
//       } catch (error) {
//         // Handle errors here
//         return Promise.reject(error);
//       }
//     }
//     refresh = false;
//     return Promise.reject(error);
//   }
// );

//we intercept every response
clienteAxios.interceptors.response.use(
  async (config) => {
    if (DEBUG === "S") {
      _printResponse(config.data);
    }
    return config;
  },
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      removeCookie("user");
      removeCookie("token");
      // Sincronizar Redux store y redirigir al login
      import("../redux/store").then(({ default: store }) => {
        store.dispatch({ type: "EVENTO_LOGOUT_EXITO", payload: true });
      });
      window.location.href = "/";
    }
    if (DEBUG === "S") {
      if (error.response) {
        // client received an error response (5xx, 4xx)
        _printResponse(error.response);
      } else if (error.request) {
        // client never received a response, or request never left
        _printResponse(error.request);
      } else {
        // anything else
        _printResponse(error);
      }
    }
    return Promise.reject(error);
  }
);

function _printRequest(method, request, usedHeaders, data) {
  console.log(
    `\nREQUEST\nMethod: ${method}\nEndpoint: ${request}\nHeaders: ${JSON.stringify(usedHeaders, null, 2)}\nBODY: ${JSON.stringify(data)}`
  );
}

function _printResponse(result) {
  console.log(`\nRESPONSE:\n${JSON.stringify(result, null, 2)}`);
}

export default clienteAxios;
